export default {
  appKey: '',
  apiKey: '',
  endpoint: '',
  appSecret: '',
  dispatchRef: '',
  accountNumber: '',
  unmanagedAccountNumber: '',
}
